export const APOLLO_LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_brand-command-22/artifacts/n9a8v04m_Untitled%20design%20-%202026-08-04T231027.945.webp";

export const APOLLO_PRIMARY_LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_brand-command-22/artifacts/2ojdu1o7_Untitled%20design%20-%202026-08-06T223418.025.png";

export const APOLLO_TAGLINE = "ELEVATE BEYOND THE ORDINARY.";

export const STRAIN_COLORS = {
  indica: "#B02065",   // Apollo Magenta
  sativa: "#FBC90C",   // Apollo Yellow
  hybrid: "#E15C2C",   // Apollo Orange
};

export const APOLLO_COLORS = {
  yellow: { hex: "#FBC90C", pantone: "PANTONE 7548 C", name: "Apollo Yellow", meaning: "Clarity and visibility — used to guide, highlight, and direct focus." },
  orange: { hex: "#E15C2C", pantone: "PANTONE 17-1464 TPX", name: "Apollo Orange", meaning: "Activation and forward motion — the moment the system engages." },
  magenta: { hex: "#B02065", pantone: "PANTONE 675 C", name: "Apollo Magenta", meaning: "Depth and distinction — a controlled accent for emphasis and memorability." },
};

export function strainClass(strain) {
  const s = (strain || "").toLowerCase();
  if (s === "indica") return "strain-indica";
  if (s === "sativa") return "strain-sativa";
  if (s === "hybrid") return "strain-hybrid";
  return "bg-muted text-foreground";
}
